import { useMutation } from "@tanstack/react-query"

import { _extendWithAuthPersistence } from "../utils"
import { googleLogin } from "../../../api/auth"

export function useLoginWithGoogle(config = {}) {
  config = _extendWithAuthPersistence(config)
  return useMutation({ mutationFn: googleLogin, ...config })
}
